var _g, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandscapeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 192,
    viewBox: "0 0 173 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4466 188.666H156.766L168.796 179.643V119.828L154.761 111.14L29.4491 112.476L19.4241 122.501V179.643L28.4466 188.666Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.798 140.546V126.01C169.798 117.982 162.617 111.474 153.758 111.474L36.1318 111.474C27.2732 111.474 20.0919 117.982 20.0919 126.01V174.464C20.0919 182.492 27.2732 189 36.1318 189H153.758C162.617 189 169.798 182.492 169.798 174.464V159.928M169.798 140.546H159.105V159.928H169.798M169.798 140.546V159.928M36.1318 140.546V159.928",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8301 155.477V17.058L77.0975 4.0813H12.5742L3.20215 19.2208L4.64401 154.395L15.458 165.209H77.0975L86.8301 155.477Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.923 3H19.2427C10.5828 3 3.5625 10.7465 3.5625 20.3023V147.186C3.5625 156.742 10.5828 164.488 19.2427 164.488H71.5102C80.1701 164.488 87.1904 156.742 87.1904 147.186V20.3023C87.1904 10.7465 80.1701 3 71.5102 3H55.8299M34.923 3V14.5349H55.8299V3M34.923 3H55.8299M34.923 147.186H55.8299",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.158 84.4396L153.742 97.5165L153.747 97.5109M99.3722 54.6416C114.581 43.9924 135.543 47.6886 146.192 62.8972C149.705 67.914 151.657 73.5568 152.149 79.2489L153.747 97.5109M166.819 81.9321L153.747 97.5109",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscapeLogo);
export default __webpack_public_path__ + "static/media/landscapeLogo.731a6bec8253e9c178fe8a5f6fe1ee24.svg";
export { ForwardRef as ReactComponent };